export const handleScrollIntoView = (replyId) => {
  const element = document.querySelector(`[data-id="${replyId}"]`);

  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "end" });
    // add animation
    element.classList.remove("animate-replied-msg");
    void element.offsetWidth;
    element.classList.add("animate-replied-msg");
  }
};
